<script setup lang="ts">
import { type PropType } from 'vue';

import { type SaleListingItemEntity } from '~/types/sale.type';

// PROPS
const { isLoading, sales } = defineProps({
    isLoading: { type: Boolean, required: true },
    sales: { type: Array as PropType<SaleListingItemEntity[]>, default: () => [] },
    totalItems: { type: Number, default: 0 },
});

// COMPOSABLES
const { navigationItems } = useSlpNavigationItems();
const { tt } = useTypedI18n();
const { setTrackingReferralListName, trackSlpSelectSale } = useTracking();

const onSlpCardNavigate = (): void => {
    trackSlpSelectSale();
    setTrackingReferralListName('page');
};
</script>

<template>
    <BaseWidthContainer as="section" class="relative pb-6 lg:grid lg:grid-cols-4 lg:gap-8">
        <aside class="mr-6 hidden pt-9 lg:block">
            <div class="relative flex flex-col gap-y-6">
                <p class="mb-5 flex flex-row items-center gap-3 leading-6 font-bold">
                    <UIcon name="lucide:sliders-horizontal" class="size-6" /> {{ tt('slp.filters.label') }}
                </p>
                <SlpFilters />
            </div>
        </aside>
        <div class="flex flex-col gap-y-4 pt-6 md:pt-7 lg:col-span-3">
            <SlpNavigation :items="navigationItems" />
            <div class="flex flex-col justify-between gap-4">
                <SlpResults :total="totalItems" />
                <div class="flex flex-row gap-2">
                    <LazySlpFiltersModalButton class="lg:hidden" />
                    <SlpAppliedFilter />
                </div>
            </div>
            <SlpSorting />

            <SlpListGrid :sales="sales" :is-loading="isLoading" :total="totalItems">
                <template #empty-state>
                    <slot name="empty-state">
                        <SlpEmptyState />
                    </slot>
                </template>
                <template #skeleton>
                    <SlpCardSkeleton />
                </template>
                <template #default="{ sale }">
                    <SlpCard :sale="sale" @navigate="onSlpCardNavigate" />
                </template>
            </SlpListGrid>
            <SlpBrandDescription />
        </div>
    </BaseWidthContainer>
</template>
